import React from 'react'
import ReactMarkdown from 'react-markdown'

export const Edit = ({ config }) => (
  <ReactMarkdown>{config.helpText}</ReactMarkdown>
)
